/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path"
    unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff"
    active-text-color="#ffd04b">
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="">
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{ menu.menuname }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/' + chmenu.url" :key="chmenu.menuid">
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{ chmenu.menuname }}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { agentList } from '../api/agentMG'

export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    let res = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: 'li-icon-xiangmuguanli',
          menuname: '编号管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: 'icon-cat-skuQuery',
              menuname: '编号列表',
              hasThird: 'N',
              url: 'camp/camplist',
              menus: null
            },
            {
              menuid: 3,
              icon: 'icon-cat-skuQuery',
              menuname: '编号分类列表',
              hasThird: 'N',
              url: 'camp/camplist2',
              menus: null
            },
            
            {
              menuid: 5,
              icon: 'icon-cat-skuQuery',
              menuname: '页面管理',
              hasThird: 'N',
              url: 'maps/maps',
              menus: null
            },
            {
              menuid: 6,
              icon: 'icon-cat-skuQuery',
              menuname: '屏蔽管理',
              hasThird: 'N',
              url: 'camp/camplist3',
              menus: null
            },
            {
              menuid: 7,
              icon: 'icon-cat-skuQuery',
              menuname: '识别格式',
              hasThird: 'N',
              url: 'camp/camplist4',
              menus: null
            },
            {
              menuid: 8,
              icon: 'icon-cat-skuQuery',
              menuname: '换行格式',
              hasThird: 'N',
              url: 'camp/camplist6',
              menus: null
            },
            {
              menuid: 9,
              icon: 'icon-cat-skuQuery',
              menuname: '间隔管理',
              hasThird: 'N',
              url: 'camp/camplist5',
              menus: null
            },
            {
              menuid: 10,
              icon: 'icon-cat-skuQuery',
              menuname: '关键字后换行管理',
              hasThird: 'N',
              url: 'camp/camplist7',
              menus: null
            },
            {
              menuid: 11,
              icon: 'icon-cat-skuQuery',
              menuname: '分别关键字管理',
              hasThird: 'N',
              url: 'camp/camplist8',
              menus: null
            },
            {
              menuid: 12,
              icon: 'icon-cat-skuQuery',
              menuname: '必须按格式管理',
              hasThird: 'N',
              url: 'camp/camplist9',
              menus: null
            },
            {
              menuid: 13,
              icon: 'icon-cat-skuQuery',
              menuname: '混合类别关联列表',
              hasThird: 'N',
              url: 'camp/camplist10',
              menus: null
            },
            {
              menuid: 14,
              icon: 'icon-cat-skuQuery',
              menuname: '混合类别',
              hasThird: 'N',
              url: 'camp/camplist11',
              menus: null
            },
            {
              menuid: 15,
              icon: 'icon-cat-skuQuery',
              menuname: '行尾关键字不合并',
              hasThird: 'N',
              url: 'camp/camplist12',
              menus: null
            },
            {
              menuid: 16,
              icon: 'icon-cat-skuQuery',
              menuname: '混合类别关联列表二',
              hasThird: 'N',
              url: 'camp/camplist13',
              menus: null
            },
            {
              menuid: 17,
              icon: 'icon-cat-skuQuery',
              menuname: '混合类别二',
              hasThird: 'N',
              url: 'camp/camplist14',
              menus: null
            },
            {
              menuid: 18,
              icon: 'icon-cat-skuQuery',
              menuname: '用户默认类别',
              hasThird: 'N',
              url: 'camp/camplist15',
              menus: null
            },
            {
              menuid: 19,
              icon: 'icon-cat-skuQuery',
              menuname: '用户默认客户、厂家',
              hasThird: 'N',
              url: 'camp/camplist16',
              menus: null
            },
            {
              menuid: 20,
              icon: 'icon-cat-skuQuery',
              menuname: '替换列表',
              hasThird: 'N',
              url: 'camp/camplist17',
              menus: null
            },
          ]
        },
        {
          menuid: 33,
          icon: 'li-icon-xitongguanli',
          menuname: '用户管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 34,
              icon: 'icon-cus-manage',
              menuname: '用户列表',
              hasThird: 'N',
              url: 'system/Role',
              menus: null
            },
            {
              menuid: 34,
              icon: 'icon-cus-manage',
              menuname: '密码修改',
              hasThird: 'N',
              url: 'maps/maps2',
              menus: null
            }
          ]
        },
        {
          menuid: 40,
          icon: 'li-icon-xitongguanli',
          menuname: '代理管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 41,
              icon: 'icon-cus-manage',
              menuname: '代理列表',
              hasThird: 'N',
              url: 'system/agent',
              menus: null
            }
          ]
        },
        //   {
        //     menuid: 71,
        //     icon: 'li-icon-xitongguanli',
        //     menuname: '系统管理',
        //     hasThird: null,
        //     url: null,
        //     menus: [
        //       {
        //         menuid: 72,
        //         icon: 'icon-cus-manage',
        //         menuname: '用户管理',
        //         hasThird: 'N',
        //         url: 'system/user',
        //         menus: null
        //       },
        //       {
        //         menuid: 174,
        //         icon: 'icon-cms-manage',
        //         menuname: '菜单管理',
        //         hasThird: 'N',
        //         url: 'system/Module',
        //         menus: null
        //       },
        //       {
        //         menuid: 73,
        //         icon: 'icon-news-manage',
        //         menuname: '角色管理',
        //         hasThird: 'N',
        //         url: 'system/Role',
        //         menus: null
        //       },
        //       {
        //         menuid: 74,
        //         icon: 'icon-cs-manage',
        //         menuname: '公司管理',
        //         hasThird: 'N',
        //         url: 'system/Dept',
        //         menus: null
        //       },
        //       {
        //         menuid: 75,
        //         icon: 'icon-promotion-manage',
        //         menuname: '系统环境变量',
        //         hasThird: 'N',
        //         url: 'system/Variable',
        //         menus: null
        //       },
        //       {
        //         menuid: 76,
        //         icon: 'icon-cms-manage',
        //         menuname: '权限管理',
        //         hasThird: 'N',
        //         url: 'system/Permission',
        //         menus: null
        //       }
        //     ]
        //   },
        //   {
        //     menuid: 128,
        //     icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
        //     menuname: '支付管理',
        //     hasThird: null,
        //     url: null,
        //     menus: [
        //       {
        //         menuid: 129,
        //         icon: 'icon-provider-manage',
        //         menuname: '支付配置信息',
        //         hasThird: 'N',
        //         url: 'machine/MachineConfig',
        //         menus: null
        //       },
        //       {
        //         menuid: 175,
        //         icon: 'icon-provider-manage',
        //         menuname: '支付配置',
        //         hasThird: 'N',
        //         url: 'pay/Config',
        //         menus: null
        //       }
        //     ]
        //   }

      ],
      msg: 'success'
    }
    this.allmenu = res.data
    // 按代理在“用户管理”下动态生成子列表
    this.loadAgentMenus()

    // menu(localStorage.getItem('logintoken'))
    //   .then(res => {
    //     console.log(JSON.stringify(res))
    //     if (res.success) {
    //       this.allmenu = res.data
    //     } else {
    //       this.$message.error(res.msg)
    //       return false
    //     }
    //   })
    //   .catch(err => {
    //     this.$message.error('菜单加载失败，请稍后再试！')
    //   })
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
    // 代理增删后刷新代理子菜单
    this.$root.Bus.$on('agentChanged', () => {
      this.loadAgentMenus()
    })
  },
  methods: {
    // 拉取代理列表，在“用户管理”组下为每个代理追加一个以其用户名命名的子列表
    loadAgentMenus() {
      const group = this.allmenu.find(m => m.menuname === '用户管理')
      if (!group) return
      if (!Array.isArray(group.menus)) group.menus = []
      // 先清除上一次动态加入的项
      group.menus = group.menus.filter(m => typeof m.menuid !== 'string' || m.menuid.indexOf('au_') !== 0)
      agentList({ page: 1, pageSize: 200 }).then(r => {
        if (r.code != 0) return
        const list = (r.data && r.data.list) || []
        list.forEach(a => {
          group.menus.push({
            menuid: 'au_' + a.id,
            icon: 'icon-cus-manage',
            menuname: a.username,
            hasThird: 'N',
            url: 'system/AgentUser?agentId=' + a.id + '&name=' + encodeURIComponent(a.username),
            menus: null
          })
        })
      }).catch(() => {})
    }
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

.el-menu-item-group__title {
  padding: 0px;
}

.el-menu-bg {
  background-color: #1f2d3d !important;
}

.el-menu {
  border: none;
}

.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}

.logoimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue